import React, { ReactNode } from 'react';
import './Section.css'

interface SectionProps {
    children: ReactNode
    id: string
    sectionTitle?: string
    titleColor?: string
    sectionSubtitle?: string
    subtitleColor?: string
}

function Section({ children, id, sectionTitle, sectionSubtitle, titleColor = '#4D4D4D', subtitleColor = '#4D4D4D' }: SectionProps) {

    return (
        <div className='section centered scrollable-section' id={id}>
            <div className='section-main-container'>
                {sectionTitle && 
                <div className='section-title'>
                    <h2 style={{ color: titleColor }}>{sectionTitle}</h2>
                    <h3 style={{ color: subtitleColor }}>{sectionSubtitle}</h3>
                </div>
                }
                {children}
            </div>
        </div>
    );
}

export default Section